import * as yup from 'yup';

import { getEmptyErrorMessage } from 'coreOld/yup';

export const uomConversionFormSchema = yup.object().shape({
  fromUom: yup.string().nullable().required(getEmptyErrorMessage('Base UOM')),
  toUom: yup.string().nullable().required(getEmptyErrorMessage('Alternate UOM')),
  multiplier: yup
    .number()
    .nullable()
    .min(0, 'Multiplier must be a number greater than zero')
    .typeError('Multiplier must be a number greater than zero')
    .required(getEmptyErrorMessage('Multiplier')),
});
